import {createTheme} from "@mui/material";
import logo from "assets/images/logos/fifa_plus_logo.svg";
import warningIcon from "apps/FANTASY_CLASSIC/assets/images/icons/warning.svg";

declare module "@mui/material/styles" {
	// allow configuration using `createTheme`
	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface ThemeOptions {
		[key: string]: unknown;
	}
}

export const DARK_BLUE = "linear-gradient(180deg, #03122B 0%, #00287A 100%)";
export const RED = "#F43056";

const themeObject = {
	baseFont: "'Qatar2022', sans-serif",
	background: "#550065",
	primary: "#550065",
	secondary: "#ffffff",
	red: "#D01515",
	lightGrey: "#E5E5E5",
	active: "#00CFB7",
	text: {
		primary: "#ffffff",
		secondary: "#0A0541",
		tertiary: "#A5ACBB",
		active: "#00E99D",
	},
	global: {
		header_sub_icon_color: "#fff",
		header_sub_icon_bg_color: "#6e267d",
		header_sub_icon_box_shadow: "none",
		header_sub_line_color: "#00e99d",
		header_background: "#020F2A",
		header_sub_nav_background: "#550065",
		header_hover_color: "#00B8FF",
		header_dropdown_hover_color: "linear-gradient(92.55deg, #C34AE9 -53.15%, #00B8FF 160.47%)",
		leagues_background: "#EEEEE4",
		leagues_active_background: "#00CFB7",
		leagues_active_color: "#000",
		leagues_head_background: "#F3F3F3",
		leagues_head_text: "#6A6967",
		leagues_text: "#000000",
		leagues_text_secondary: "#000000",
		leagues_text_tertiary: "#6A6967",
		leagues_remove_icon_color: "#d01515",
		leagues_checkbox_active: "#767676",
		leagues_nav_background: "#550065",
		leagues_nav_text: "#B6B5B2",
		leagues_nav_active_text: "#ffffff",
		leagues_label_text: "#6A6967",
		leagues_private_background: "#FF004C",
		leagues_public_background: "#00CFB7",
		leagues_private_color: "#ffffff",
		leagues_public_color: "#ffffff",
		leagues_divider_color: "#550065",
		leagues_join_background: "#00CFB7",
		leagues_logo: logo,
		leagues_warning_icon: warningIcon,
		help_background: "#EEEEE4",
		help_nav_background: "#550065",
		help_title_color: "#000000",
	},
	button: {
		primary: {
			color: "#ffffff",
			background: "#dc0019",
			borderColor: "#dc0019",
			hoverColor: "#ffffff",
			hoverBackground: "#ff004c",
			hoverBorderColor: "#ff004c",
		},
		secondary: {
			color: "#550065",
			background: "#ffffff",
			borderColor: "#550065",
			hoverColor: "#640077",
			hoverBackground: "#ffffff",
			hoverBorderColor: "#640077",
		},
		warning: {
			color: "#ffffff",
			background: "#D01515",
			borderColor: "#D01515",
			hoverColor: "#fff",
			hoverBackground: "#e33434",
			hoverBorderColor: "#e33434",
		},
	},
	roundNavigation: {
		active: "linear-gradient(46.11deg, #550065 2.69%, #873EB4 93.88%)",
		subText: "#30D148",
		lockedText: "#FFBF00",
	},
};

export const theme = createTheme(themeObject);
type ThemeInterface = typeof themeObject;

declare module "styled-components" {
	// Allows change type of  theme to avoid any
	/* eslint-disable @typescript-eslint/no-empty-interface */

	// eslint-disable-next-line @typescript-eslint/naming-convention
	export interface DefaultTheme extends ThemeInterface {}
}
